import styled, { css } from 'styled-components';
import { TabPanel } from '@chakra-ui/react';

interface DiaPARAMS {
  dia: number;
}
interface HorasPARAMS {
  inicio: number;
  tempo: number;
}

export const Container = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3.42rem;
  margin-left: 4.4rem;
  padding: 1rem 1.5rem 5rem;
  // border: 2px solid red;

  > h1 {
    font-size: 20px;
    font-weight: 500;
    padding: 10px 0;
  }

  // 760px
  @media (max-width: 47.5rem) {
    margin-top: 3.9rem;
    margin-left: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;

  h1 {
    font-size: 24px;
    font-weight: 500;
  }
  h2 {
    font-size: 20px;
    color: #607d8b;
  }
`;

export const Horario = styled.div`
  display: flex;
`;

export const SemanaDias = styled.div`
  display: flex;
  // border: 1px solid green;

  hr {
    background-color: #cfd8dc;
    border: none;
    width: 3120%; // 3164%;
    height: 1px;
    margin: 0px 0 16px 45px;
    position: absolute;
  }

  .indice {
    display: flex;
    flex-direction: column;
    // border: 1px solid red;
    height: 490px;
    position: relative;
    top: 80px;
    margin-right: 20px;
    padding: 0;

    .item-indice {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-top: 16px;

      :first-child {
        margin-top: 0;
      }
      :last-child {
        margin-top: 12px;
      }
    }
  }
`;

export const DiaSemana = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;

  h1 {
    font-size: 16px;
    font-weight: 600;
  }

  h2 {
    font-size: 13px;
    font-weight: 500;
    color: var(--azul-razio);

    border: 1px solid var(--azul-razio);
    border-radius: 10px;

    padding: 0 5px;
    margin: 10px 15px;
  }
`;

export const HorariosDia = styled.div<DiaPARAMS>`
  display: flex;
  flex-direction: column;
  border: 1px solid #b0bec5;
  border-right: 0;
  margin-top: 10px;
  margin-right: 10px;
  height: 480px;
  width: 100%;
  position: sticky;
  cursor: pointer;
  z-index: 1;

  .btn-oculto {
    width: 105%;
    height: 100%;
  }

  ${props =>
    props.dia === 1
      ? css`
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
        `
      : props.dia === 7 &&
        css`
          border-right: 1px solid #b0bec5;
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        `}
`;

export const Periodo = styled.button<HorasPARAMS>`
  display: flex;
  background-color: rgba(0, 128, 0, 0.1);
  border: 1px solid rgba(0, 128, 0, 0.3); // #cfd8dc;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-left: 0;
  width: 95%;
  position: absolute;
  cursor: pointer;
  z-index: 99999;

  ${props => css`
    height: ${props.tempo * 20}px;

    top: ${props.inicio * 20}px;
  `}

  h3 {
    font-size: 14px;
    padding: 0 10px;
  }
`;

export const TabsView = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .tabs {
    display: flex;
    flex-direction: column;
    width: 100%;

    .tab-list {
      display: flex;
      color: #78909c;

      .tab {
        font-size: 22px;
        font-weight: 500;

        :focus {
          box-shadow: 0 0 0 0;
          border: 0 0;
        }
      }
    }

    .tab-panels {
      width: 100%;
      height: 93.5%;
      position: relative;
      // border: 2px solid orange;

      .tab-panel {
        width: 100%;
        padding: 0;
      }
    }
  }
`;

export const TabHorarios = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 20px;
  margin-bottom: 50px;
`;

export const TabPausaProgramada = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 50px;
`;

export const ListPausas = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 20px;
  list-style: none;
  margin: 20px 20px 0 0;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      font-size: 18px;
      white-space: pre-line;
    }
  }
`;

export const ItemPausa = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 0;

  h1 {
    font-size: 20px;
    font-weight: 500;
  }
`;

export const Pausa = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #cfd8dc;
  padding: 20px;

  .inicio {
    display: flex;
    flex-direction: column;
    justify-content: center;

    h1 {
      font-size: 18px;
      font-weight: 500;
    }
    h2 {
      font-size: 16px;
    }
    h3 {
      font-size: 14px;
      color: #78909c;
    }
  }

  .fim {
    display: flex;
    align-items: center;

    > svg {
      font-size: 26px;
      font-weight: 600;
      color: #607d8b;
      margin-right: 25px;
    }

    div {
      margin-right: 25px;
    }

    .comeca-termina {
      display: flex;
      flex-direction: column;
      justify-content: center;

      h1 {
        font-size: 18px;
        font-weight: 500;
      }
      h2 {
        font-size: 16px;
      }
    }
  }

  .btn-delete {
    display: flex;
    align-items: center;

    svg {
      font-size: 24px;
      color: var(--red-razio);
    }
  }
`;

export const NenhumaPausa = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 150px;
    margin: 50px 0 30px 0;
  }
  h1 {
    font-size: 20px;
    font-weight: 500;
  }
  h2 {
    font-size: 18px;
    margin-bottom: 20px;
  }
`;
